import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  IconButton,
  Checkbox,
  Modal,
  Autocomplete,
  TextField,
} from "@mui/material";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import DownloadIcon from "@mui/icons-material/Download";
import { toPng } from "html-to-image";

import { QRCodeSVG } from "qrcode.react";
import { PaymentBackIcon, SampleTicketPicture } from "../../Svg/icons";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Ticket from "../../components/MyEvents/AddEvent/CreateTicket/Ticket/Ticket";
import Template1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Template1";
import Band from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band";
import Ticket6 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket6";
import Ticket5 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket5";
import Ticket7 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket7";
import Ticket8 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket8";
import Ticket9 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket9";
import Band2 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band2";
import Band1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band1";
import Band3 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band3";
import moment from "moment";
import GXWhiteLogo from "../../Images/GX_Logo_White_No_Bg.png";
import GoogleWallet from "../../Images/google_wallet_logo.png";
import AppleWallet from "../../Images/Apple_Wallet.svg";
import dayjs from "dayjs";
import { notification } from "antd";
import { useAddTicketToGoogleWalletMutation } from "../../Redux/apis/ApiSlice";
const TicketInvoice = () => {
  const [loadingShare, setLoadingShare] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [shareableLinks, setShareableLinks] = useState([]);
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const [loadingFetchContacts, setLoadingFetchContacts] = useState(false);

  // Access the 'name' property
  const buyerName = userData.name;
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const ticketRef = useRef(null);
  const ticketRefs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [emails, setEmails] = useState([]);
  const [token, setToken] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("accessToken"));
  const [selectedEmails, setSelectedEmails] = useState([]);

  let authtoken = localStorage.getItem("authToken");
  const [walletLink, setWalletLink] = useState("");
  const userName = userData?.name;
  const [addTicketToGoogleWallet, { isLoading: isAddingToGoogleWallet }] =
    useAddTicketToGoogleWalletMutation();
  const { incomingEvent, ticketSummary, bookingResponse } =
    location.state || {};

  const ticketPriceMap = incomingEvent?.ticket[0]?.subTickets?.reduce(
    (acc, ticket) => {
      acc[ticket?.ticketType?.typeName] = ticket?.price;
      return acc;
    },
    {}
  );

  const mappedTicketTypes = bookingResponse.booking.ticketTypes
    .filter((ticket) => ticket.quantity > 0)
    .map((ticket) => ({
      type: ticket.type,
      quantity: ticket.quantity,
      price: ticket.totalPrice,
    }));

    const preloadImages = async (container) => {
      const images = Array.from(container.querySelectorAll("img"));
      await Promise.all(
        images.map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve; // Don't fail on error
          });
        })
      );
      // Extra delay for good measure
      await new Promise(resolve => setTimeout(resolve, 200));
    };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const downloadTicket2 = async (index) => {
    const ticketElement = ticketRefs.current[index];
    if (!ticketElement) {
      console.error(`Ticket element at index ${index} is null`);
      notification.error({
        message: "Ticket element not found!",
      });
      return;
    }

    const downloadButton = ticketElement.querySelector(".download-button");

    try {
      await preloadImages(ticketElement);
      if (downloadButton) downloadButton.style.visibility = "hidden";

      // Safari workaround
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        await delay(1000);
      }

      await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve))
      );

      const ticketImage = await toPng(ticketElement, {
        useCORS: true,
        quality: 1, // Ensure highest quality
        pixelRatio: 2, // For retina displays
      });

      // ✅ Add this missing download logic
      const link = document.createElement("a");
      link.href = ticketImage;
      link.download = `ticket_${index + 1}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      notification.error({
        message: "Error downloading ticket! Please try again.",
      });
      console.error("Error downloading ticket:", error);
    } finally {
      if (downloadButton) downloadButton.style.visibility = "";
    }
  };

  useEffect(() => {
    return () => {
      ticketRefs.current = []; // Only clear on unmount
    };
  }, []);

  const handleAddToGoogleWallet = async (ticketId) => {
    try {
      const response = await addTicketToGoogleWallet({
        userName: userName,
        ticketId: ticketId,
      });
      setWalletLink(response?.data?.saveUrl);
      window.open(response?.data?.saveUrl, "_blank");
      
    } catch (error) {
      console.error("Error adding ticket to Google Wallet:", error);
    }
  };

  const handleAddToAppleWallet = async (ticketId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/booking/apple-wallet`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authtoken}`,
          },
          body: JSON.stringify({
            userName,
            ticketId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to generate Apple Wallet pass");
      }

      const blob = await response.blob();

      // Create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ticket_${ticketId}.pkpass`;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error adding ticket to Apple Wallet:", error);
    }
  };

  const downloadInvoice = async () => {
    const pdf = new jsPDF("p", "pt", "a4"); // A4 size in portrait orientation

    // Set Background color to brand color (#061F44)
    pdf.setFillColor(0, 0, 0); //rgb(0, 0, 0)
    pdf.rect(0, 0, 595, 842, "F"); // Fill entire page with brand color

    // Add GX Tickets Logo
    pdf.addImage(GXWhiteLogo, "PNG", 40, 40, 60, 60); // Top-left corner

    // Title Section
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(30);
    pdf.setTextColor(255, 255, 255); // White
    pdf.text("INVOICE", 40, 130);

    // Line under title
    pdf.setLineWidth(2);
    pdf.setDrawColor(255, 255, 255); // White
    pdf.line(40, 135, 550, 135);

    // Event and Booking Details Section
    pdf.setFontSize(14);
    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(255, 255, 255); // White text

    const details = [
      { label: "Event Name:", value: incomingEvent?.eventName },
      // { label: "Organization:", value: incomingEvent?.organizationName },
      {
        label: "Organizer:",
        value: incomingEvent?.eventOrganizers[0].user.fullName,
      },
      {
        label: "Event Date:",
        value:
          bookingResponse?.eventDetails?.startDateTime &&
          dayjs(bookingResponse?.eventDetails?.startDateTime).format(
            "MM/DD/YYYY"
          ),
      },
      {
        label: "Event Time:",
        value:
          bookingResponse?.eventDetails?.startDateTime &&
          dayjs(bookingResponse?.eventDetails?.startDateTime).format("hh:mm A"),
      },
      { label: "Location:", value: incomingEvent?.location },
      {
        label: "Total Amount:",
        value: `$ ${bookingResponse?.booking?.totalPrice}`,
      },

      {
        label: "Booking Date:",
        value:
          bookingResponse?.booking?.date &&
          dayjs(bookingResponse?.booking?.date).format("MM/DD/YYYY"),
      },
    ];

    let yPosition = 160;
    details.forEach((detail) => {
      // Label
      pdf.setFont("helvetica", "bold");
      pdf.text(detail.label, 40, yPosition);

      // Value (wrapped to fit within the page)
      pdf.setFont("helvetica", "normal");
      const wrappedText = pdf.splitTextToSize(detail.value, 300); // Adjust width if needed
      wrappedText.forEach((line) => {
        pdf.text(line, 200, yPosition);
        yPosition += 20; // Move down for the next line
      });

      yPosition += 10; // Extra spacing between details
    });

    // Divider Line before Ticket Details
    yPosition += 10;
    pdf.setLineWidth(1);
    pdf.line(40, yPosition, 550, yPosition);
    yPosition += 20;

    // Ticket Details Section
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("Ticket Details", 40, yPosition);
    yPosition += 30;

    pdf.setFontSize(14);
    mappedTicketTypes.forEach((ticket, index) => {
      pdf.setFont("helvetica", "bold");
      pdf.text(`Ticket Type:`, 40, yPosition);
      pdf.setFont("helvetica", "normal");
      pdf.text(ticket.type, 200, yPosition);

      pdf.setFont("helvetica", "bold");
      pdf.text(`Tickets Booked:`, 40, yPosition + 20);
      pdf.setFont("helvetica", "normal");
      pdf.text(`${ticket.quantity}`, 200, yPosition + 20);

      yPosition += 50;
    });

    // Footer Section
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "italic");
    pdf.setTextColor(255, 255, 255);
    pdf.text("Thank you for booking with GX Tickets!", 40, 770);
    pdf.text("Visit www.gxtickets.com for more details.", 40, 790);

    // Footer Line
    pdf.setLineWidth(2);
    pdf.line(40, 800, 550, 800);

    // Save the PDF
    pdf.save(`booking_invoice_${incomingEvent?.eventName}.pdf`);
  };

  const currentDate = new Date();
  const options = { year: "numeric", month: "long", day: "numeric" };
  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle cases where date is null or undefined

    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);

    return date.toLocaleDateString("en-US", options);
  };

  // Share ticket:

  const XIcon = () => (
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/5/53/X_logo_2023_original.svg"
      alt="X (Twitter) logo"
      width={32}
      height={32}
      style={{ borderRadius: "50%" }}
    />
  );
  // Upload file to S3
  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const result = await response.json();
      return result.Location;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };
  // Share selected tickets
  const handleShareSelectedTickets = async () => {
    const links = [];
    try {
      setLoadingShare(true);
      for (const index of selectedTickets) {
        const ticketElement = ticketRefs.current[index]; // Direct element access
        if (!ticketElement) continue;

        const dataUrl = await toPng(ticketElement, {
          useCORS: true,
          quality: 1,
        });
        const blob = await fetch(dataUrl).then((res) => res.blob());
        const file = new File([blob], `ticket-${index}.png`, {
          type: "image/png",
        });
        const s3Url = await uploadFileToS3(file);
        links.push(s3Url);
      }
      setShareableLinks(links);
      setModalOpen(true);
    } catch (error) {
      console.error("Error sharing selected tickets:", error);
    } finally {
      setLoadingShare(false);
    }
  };

  // Generate encoded message for sharing
  const handleShareLinks = () => {
    const emailBody = shareableLinks.join("\n");
    return encodeURIComponent(`Check out these tickets:\n\n${emailBody}`);
  };

  const toggleTicketSelection = (index) => {
    setSelectedTickets((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index]
    );
  };

  const fetchContacts = async () => {
    setLoadingFetchContacts(true);
    try {
      if (!accessToken || emails.length === 0) {
        window.google.accounts.oauth2
          .initTokenClient({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            scope: "https://www.googleapis.com/auth/contacts.readonly",
            callback: async (response) => {
              if (response.access_token) {
                localStorage.setItem(
                  "accessToken",
                  JSON.stringify(response.access_token)
                );
                setToken(response.access_token);

                const contactResponse = await fetch(
                  `https://people.googleapis.com/v1/people/me/connections?pageSize=1000&personFields=names,emailAddresses`,
                  {
                    headers: {
                      Authorization: `Bearer ${response.access_token}`,
                    },
                  }
                );

                if (!contactResponse.ok) {
                  throw new Error("Failed to fetch contacts");
                }

                const data = await contactResponse.json();
                const contactsWithEmails = data?.connections?.filter(
                  (contact) => contact.emailAddresses
                );
                const emailList = contactsWithEmails?.map(
                  (contact) => contact.emailAddresses[0]?.value
                );

                if (emailList && emailList.length > 0) {
                  setEmails(emailList);
                  notification.success({
                    message: "Contacts fetched successfully!",
                  });
                } else {
                  setEmails([]);
                  notification.info({
                    message: "No contacts found in your network!",
                  });
                }
              } else {
                throw new Error("Error retrieving access token");
              }
            },
          })
          .requestAccessToken();
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      notification.error({
        message: "Failed to fetch contacts!",
        // description: error.message,
      });
    } finally {
      setLoadingFetchContacts(false);
    }
  };

  const encodedMessage = handleShareLinks();

  const handleSendEmails = (recipients) => {
    if (!recipients || recipients.length === 0) return;

    const recipientEmails = recipients.join(",");
    const emailSubject = encodeURIComponent("Check out these tickets!");
    const emailBody = encodeURIComponent(encodedMessage);

    window.open(
      `mailto:${recipientEmails}?subject=${emailSubject}&body=${encodedMessage}`
    );

    notification.success({
      message: `Message sent to ${recipients.length} recipient(s)!`,
    });
  };

  return (
    <Grid p={1.5}>
      <Paper elevation={1} style={{ padding: "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            borderBottom: "1px solid #ddd",
            pb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => navigate(-3)}
              sx={{ mr: 1 }}
            >
              <PaymentBackIcon />
            </IconButton>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                color: "#061F44",
                fontSize: { xs: "1rem", sm: "1.5rem", md: "1.5rem" },
              }}
            >
              Book Tickets
            </Typography>
          </Box>
          <Button
            variant="contained"
            onClick={downloadInvoice}
            sx={{
              fontWeight: "bold",
              textTransform: "none",
              backgroundColor: "#061F44",
              width: { xs: "85px", md: "auto" },
            }}
          >
            Download Invoice
          </Button>
        </Box>

        <Grid container spacing={3}>
          {/* Left Section */}
          <Grid item xs={12} sm={4}>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mb: 1, fontStyle: "italic" }}
            >
              Booking Date:{" "}
              {bookingResponse?.booking?.date &&
                dayjs(bookingResponse?.booking?.date).format("MM/DD/YYYY")}
            </Typography>

            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" fontWeight="bold">
                {incomingEvent?.eventName}
              </Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Organization:
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {incomingEvent?.organizationName}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Organizer:
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {incomingEvent?.eventOrganizers[0].user.fullName}
                </Typography>
              </Grid>
            </Grid>

            {/* Ticket Details */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Ticket Details
              </Typography>
              <Grid container spacing={2}>
                {mappedTicketTypes.map((ticket, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{ display: "flex", columnGap: 1 }}
                    >
                      <Typography variant="subtitle2" fontWeight="bold">
                        Ticket Type:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {ticket.type}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{ display: "flex", columnGap: 2 }}
                    >
                      <Typography variant="subtitle2" fontWeight="bold">
                        Tickets Booked:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {ticket.quantity}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Box>

            {/* Event Details */}
            <Box sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ mr: 1 }}
                  >
                    Location:
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {bookingResponse?.eventDetails?.location}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    Event Date & Time:
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {bookingResponse?.eventDetails?.startDateTime &&
                      dayjs(
                        bookingResponse?.eventDetails?.startDateTime
                      ).format("MM/DD/YYYY  hh:mm A")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            {/* Price and Description */}
            <Box
              sx={{
                mt: 4,
                p: 2,
                border: "1px solid #ddd",
                borderRadius: 2,
                backgroundColor: "#E9F7EF",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Total Amount:
              </Typography>
              <Typography variant="h5" color="success.main">
                ${bookingResponse.booking.totalPrice}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                You can download the Ticket from the download button.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid mt={2} spacing={2}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              columnGap: "10px",
              rowGap: { xs: "10px", sm: "0" },
              // marginLeft: "20px",
              mb: 2,
            }}
          >
            <Button
              // type="primary"
              disabled={selectedTickets.length === 0}
              onClick={handleShareSelectedTickets}
              loading={loadingShare}
              style={{
                backgroundColor:
                  selectedTickets.length === 0 ? "#638ebf" : "#1677FF",
                color: "white",
              }}
            >
              Share Selected Tickets
            </Button>
          </Box>
          {bookingResponse?.newTickets.map((ticket, index) => {
            // Construct the ticket object
            const ticketData = {
              title: incomingEvent?.eventName,
              organizer: incomingEvent?.organizationName,
              date: dayjs(bookingResponse?.eventDetails?.startDateTime).format(
                "MM/DD/YYYY"
              ),
              time: dayjs(bookingResponse?.eventDetails?.startDateTime).format(
                "hh:mm A"
              ),
              code: ticket.code, // Use the ticket's unique code
              location: incomingEvent?.location,
              price: ticket.price, // Individual ticket price
              qrCode: ticket.qrCode, // Ticket-specific QR code
              bgColor: bookingResponse?.eventDetails?.ticket?.[0]?.color, // Use the event's ticket color
              ticketName: ticket?.ticketName,
            };

            return (
              <Grid item xs={12} sm={12} md={12} lg={10} xl={9} key={index}>
                <Grid
                  container
                  alignItems="center"
                  sx={{ overflowX: "hidden" }}
                >
                  <Box
                    sx={{
                      overflowX: "auto",
                      overflowY: "hidden",
                      width: "100%",
                      // pl: 2,
                      position: "relative",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Grid
                        item
                        xs={12}
                        md={10}
                        ref={(el) => (ticketRefs.current[index] = el)}
                        sx={{
                          minWidth: "600px",
                          position: "relative",
                          backgroundColor: "white", // Ensure background is white
                          overflow: "visible", // Prevent cropping
                          "& *": {
                            boxSizing: "border-box", // Prevent size miscalculations
                          },
                          "&:hover .download-button": { display: "flex" },
                        }}
                      >
                        {bookingResponse?.eventDetails?.ticket?.[0]
                          ?.ticketTemplate === "7" ? (
                          <Template1
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "8" ? (
                          <Ticket5
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "9" ? (
                          <Ticket6
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "10" ? (
                          <Ticket7
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "11" ? (
                          <Ticket8
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "12" ? (
                          <Ticket9
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "13" ? (
                          <Band1
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : bookingResponse?.eventDetails?.ticket?.[0]
                            ?.ticketTemplate === "14" ? (
                          <Band2
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        ) : (
                          <Band3
                            ticket={ticketData}
                            type={ticket.ticketType}
                            image={
                              bookingResponse?.eventDetails?.ticket?.[0]
                                ?.ticketPhoto
                            }
                            bookerName={bookingResponse?.bookerName}
                          />
                        )}

                        {/* Download Button - Hidden by Default, Shows on Hover */}
                        <Button
                          className="download-button"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            downloadTicket2(index);
                          }} // Remove focus after clicking
                          sx={{
                            display: "flex", // Hidden by default
                            position: "absolute",
                            top: 5,
                            right: { xs: "530px", md: "10px" }, // Keeps it aligned inside the ticket
                            minWidth: "30px",
                            width: "30px",
                            height: "28px",
                            padding: "4px",
                            zIndex: 10, // Ensures it stays on top
                            "&:hover": { backgroundColor: "#061F44" }, // Darker on hover
                          }}
                        >
                          <DownloadIcon sx={{ fontSize: "20px" }} />
                        </Button>
                      </Grid>
                      <Box mt={1} ml={1}>
                        <Checkbox
                          onChange={() => toggleTicketSelection(index)}
                          checked={selectedTickets.includes(index)}
                          label="Select"
                        />
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, marginTop: 2 }}>
                      <div
                        className="py-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleAddToGoogleWallet(ticket.id)}
                      >
                        <div className="max-w-2xl mx-auto sm:px-6 lg:px-8">
                          <div className="bg-gray-100 overflow-hidden shadow-sm sm:rounded-lg">
                            <div className="p-10">
                              <img
                                width={150}
                                src={GoogleWallet} // Make sure this file is in your `public/` folder
                                alt="Add to Google Wallet"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* )} */}
                      {/* {isSmallScreen && ( */}
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleAddToAppleWallet(ticket.id)}
                      >
                        <img
                          width={140}
                          src={AppleWallet}
                          alt="Add to Apple Wallet"
                        />
                      </Box>
                      {/* )} */}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="shareable-link-title"
        aria-describedby="shareable-link-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "300px", md: "400px" },
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 1,
            textAlign: "center",
            borderRadius: "8px",
          }}
        >
          <Typography
            id="shareable-link-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Shareable Link
          </Typography>
          {shareableLinks.length >= 0 ? (
            <div style={{ marginBottom: "10px" }}>
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <WhatsappShareButton
                  url={encodedMessage}
                  title={"Check out the tickets:"}
                  separator=": "
                >
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>

                <FacebookShareButton
                  url={encodedMessage}
                  quote={"Check out the tickets:"}
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>

                <TwitterShareButton
                  url={encodedMessage}
                  title={"Check out the tickets:"}
                >
                  {/* <TwitterIcon size={32} round /> */}
                  <XIcon />
                </TwitterShareButton>

                <LinkedinShareButton
                  url={encodedMessage}
                  summary={"Check out the tickets:"}
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>

                {/* Email */}
                <a
                  href={`mailto:?subject=Check out these tickets!&body=${encodedMessage}`}
                  style={{ textDecoration: "none" }}
                  title="Share via Email"
                >
                  <img
                    src="https://img.icons8.com/ios-filled/50/000000/email.png" // Example email icon
                    alt="Email Icon"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                  />
                </a>

                {/* Gmail */}
                <a
                  href={`mailto:?subject=Check out these tickets!&body=${encodedMessage}`}
                  style={{ marginLeft: "10px" }}
                >
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/281/281769.png"
                    alt="Gmail"
                    style={{ width: 32, height: 32, borderRadius: "50%" }}
                  />
                </a>
              </div>
            </div>
          ) : (
            // ))
            <Typography variant="body2" color="textSecondary">
              No links available.
            </Typography>
          )}
          {emails && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                // disabled={selectedEmails.length === 0}
                onClick={fetchContacts}
              >
                Fetch My Contacts
              </Button>
            </Box>
          )}

          {/* Multi-Select Autocomplete for Emails */}
          <Grid item sx={{ display: "flex" }}>
            <Autocomplete
              sx={{ width: "100%" }}
              id="email-selector"
              multiple
              freeSolo
              options={emails} // Suggestions from the emails array
              value={selectedEmails}
              onChange={(event, newValue) => setSelectedEmails(newValue)} // Update selected emails
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Email Addresses"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>

          {/* Send Button */}
          <Box sx={{ marginTop: "1rem" }}>
            <Button
              sx={{ marginTop: "1rem" }}
              onClick={() => handleSendEmails(selectedEmails)}
              disabled={selectedEmails.length === 0}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Modal>
    </Grid>
  );
};
export default TicketInvoice;
